<template>
  <div class="max-div">
    <div class="top-title-div">
        <div class="systematic-name-div">
            <p>管理平台</p>
        </div>
        <div class="systematic-zdy-div"></div>
        <div class="systematic-user-div">
            <div class="user-div-tp">用</div>
            <div>用户名</div>
            <div @click="logout">退出登录</div>
        </div>
    </div>
    <div class="bottom-title-div">
      <div class="navmenu-div">
        <div>
          <MultiLevelNavMenu 
              :DataList="menuList" 
              :FoverDataList="menuList" 
              @item-click="handleMenuItemClick"></MultiLevelNavMenu>
        </div>
        
      </div>
      <div class="content-div">
        <component :is="currentComponent" 
          :key="componentKey"
          v-if="currentComponent" 
          v-bind="componentProps"></component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitorPage',
  data() {
    return {
      menuSvgStr: `<svg t="1751286887838" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6047" width="20" height="20"><path d="M832 938.666667h-170.666667c-59.733333 0-106.666667-46.933333-106.666666-106.666667v-170.666667c0-59.733333 46.933333-106.666667 106.666666-106.666666h170.666667c59.733333 0 106.666667 46.933333 106.666667 106.666666v170.666667c0 59.733333-46.933333 106.666667-106.666667 106.666667z m-170.666667-298.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333v170.666667c0 12.8 8.533333 21.333333 21.333333 21.333333h170.666667c12.8 0 21.333333-8.533333 21.333333-21.333333v-170.666667c0-12.8-8.533333-21.333333-21.333333-21.333333h-170.666667zM362.666667 85.333333H192C134.4 85.333333 85.333333 132.266667 85.333333 192v170.666667c0 59.733333 46.933333 106.666667 106.666667 106.666666h170.666667c59.733333 0 106.666667-46.933333 106.666666-106.666666V192c0-59.733333-46.933333-106.666667-106.666666-106.666667zM832 85.333333h-170.666667c-59.733333 0-106.666667 46.933333-106.666666 106.666667v170.666667c0 59.733333 46.933333 106.666667 106.666666 106.666666h170.666667c59.733333 0 106.666667-46.933333 106.666667-106.666666V192c0-59.733333-46.933333-106.666667-106.666667-106.666667zM362.666667 554.666667H192c-59.733333 0-106.666667 46.933333-106.666667 106.666666v170.666667c0 59.733333 46.933333 106.666667 106.666667 106.666667h170.666667c59.733333 0 106.666667-46.933333 106.666666-106.666667v-170.666667c0-59.733333-46.933333-106.666667-106.666666-106.666666z" fill="#80B8F8" p-id="6048"></path></svg>`,
      menuList: [
        {"name": "业务申报", "path": "reportPage", "icon": ``, "children": []},
        {"name": "业务审核", "path": "approvePage", "icon": ``, "children": []},
        {"name": "业务统计", "path": "statisticsPage", "icon": ``, "children": []}
      ],
      iscollapse: true,
      activeMenuItem: '1-1',
      currentComponent: null,
      componentProps: {},
      componentKey: 0  // 新增一个 key 控制组件刷新
    };
  },
  methods: {
    logout() {
        localStorage.removeItem('token');
        this.$router.push({ name: 'LoginPage' });
        this.$messageX.xiaoxiti("成功", "已退出当前账号！");
    },
    handleMenuItemClick(item) {
      switch (item.path) {
        case 'reportPage':
          this.currentComponent = "reportPage";
          this.componentProps = { status: '待处理' };
          break;
        case 'approvePage':
          this.currentComponent = "reportPage";
          this.componentProps = { status: '审核中' };
          break;
        case 'statisticsPage':
          this.currentComponent = "reportPage";
          this.componentProps = { status: '统计' };
          break;
        default:
          this.currentComponent = null;
      }

      // 只要组件名变化或参数变化，就更新 key 强制刷新组件
      this.componentKey++;
    },
    isCollapse() {
      this.iscollapse = !this.iscollapse;
    },
    removelocalStorage(name) {
      localStorage.removeItem(name);
    }
  },
  mounted() {
    this.removelocalStorage("reportPageListDataInfo");
  }
};
</script>

<style scoped>
.max-div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.top-title-div {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    background-color: #3aaa85;
}

.systematic-name-div {
    width: auto;
    font-size: 3.7vh;
    font-weight: 800;
    padding-left: 30px;
}

.systematic-user-div {
  width: 20vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: center;
  font-size: 2.2vh;
  font-weight: 400;
}

.user-div-tp {
  width: 3vw;
  height: 3vw;
  border-radius: 3vw;
  background-color: aqua;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 1.3vw;
  padding-bottom: 0.2vw;
  border-color: #0000001f;
  border-style: solid;
  border-width: 2px;
  box-shadow: 9px 8px 30px 5px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.systematic-name {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 10px;
}

.systematic-zdy-div {
  width: 120px;
}

.bottom-title-div {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.menuSvgStr-div {
  width: 100%;
  height: 40px;
}

.menuSvgStr-div-ch {
  width: 50px;
}

.navmenu-div {
  width: 15vw;
  height: 100%;
  border-right: 2px solid;
  border-right-color: rgb(226 226 226);
}

.content-div {
  width: calc(100% - 15vw);
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #e8e8e8;
  box-sizing: border-box;
}
</style>



